import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const feraMediaGalleryWidget: ComponentTemplate = {
  id: "7e79069b-0171-496a-803a-43aaf0b56ab3",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Fera Media Gallery",
  leftBarCategory: { main: "productIntegrations", subCategory: "fera" },
  tags: ["product", "widget"],
  preview: "integrations/fera-media-gallery.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "feraMediaGalleryWidget",
    props: { style: { alignSelf: "stretch" } },
  },
};
